import React,{useContext,useEffect,useState}  from 'react';

import { useUrlContext } from '../context/urlContext';
import { Typography } from '@mui/material';

import { errorContext } from "../Components/ErrorDisplay";
import { useConfirm } from "../Components/ConfirmDialog";
import ParentComponent from "../Components/ParentForTableAndFormComponent";
import axios from "axios";
import ShellyLockForm from "../Forms/ShellyLockForm";


function ShellyLock(props)
{


    const { UrlHelperObj } = useUrlContext();
    const [columnInfo, setColumnInfo] = useState([
        {  title: 'Shelly-Id',dbname:'id' },
        {  title: 'URI',dbname:'server_uri' },
        {title:"Auth Key",dbname:"auth_key"},
        {title:"Channel",dbname:"channel"},
        {title:"Off-Timer",dbname:"off_timer"}

    ]);
    const[selectedLocation,setSelectedLocation] = useState(null);
    const[shellyRecords,setShellyRecords]=useState([]);
    const[isAddDisabled,setIsAddDisabled] = useState(false);
    const {handleError} = useContext(errorContext);
    const confirm = useConfirm();

    useEffect(()=>{setSelectedLocation(props.LocationRow);
    },[props.LocationRow]);

    useEffect(()=>{getShellyRecords();},[selectedLocation]);

    useEffect(()=>{
        
        if((shellyRecords?.length || 0) >= 1)
            setIsAddDisabled(true);
        else
            setIsAddDisabled(false);

    },[shellyRecords]);

    async function getShellyRecords()
    {
        if (!selectedLocation) return;
        await axios.get(UrlHelperObj.shellyLockUrl_GET(selectedLocation.id))
        .then(response => response.data)
        .then(results => setShellyRecords(Array.isArray(results) ? results : []))
        .catch(err => handleError(err));
    }
    async function deleteShellyRecord(record)
    {
        // Shelly lock is deleted by its location id (lId), not the shelly row id.
        if (!selectedLocation) return;
        const ok = await confirm({ title: 'Delete shelly lock', message: 'Are you sure you want to delete this shelly lock?', confirmText: 'Delete' });
        if (!ok) {
            return;
        }
        await axios.delete(UrlHelperObj.shellylockUrl_DELETE(selectedLocation.id))
        .then(response => response.data)
        .then(results =>console.log("delete of Shelly for location "+selectedLocation.id+" successful"))
        .catch(err => handleError(err));
        getShellyRecords();
    }
    async function editShellyRecord(record)
    {
        const data = {
            id:record.id,
            location_id:record.location_id,
            server_uri:record.server_uri,
            auth_key:record.auth_key,
            channel:record.channel,
            off_timer:record.off_timer
        }
        
        
        await axios.put(UrlHelperObj.shellylockUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Edit of shelly location "+record+" successful"))
        .catch(err => handleError(err));
        getShellyRecords();
    }
    /*function handleError(err)
    {
        setLoading(false);
        if(err.response)
        {
            console.log(err.response);
            setErrorMessage(err.response.data.message);
        }
        else if(err.request)
        {
            console.log(err.request);
        }
    }*/
    async function addShellyRecord(record)
    {
       console.log(JSON.stringify(record));
        const data = {
            id:record.id,
            location_id:record.location_id,
            server_uri:record.server_uri,
            auth_key:record.auth_key,
            channel:record.channel,
            off_timer:record.off_timer
        }
        
        console.log("ADD Shelly:"+ JSON.stringify(data));
        await axios.post(UrlHelperObj.shellylockUrl(),data)
        .then(response => response.data)
        .then(results =>console.log("Add of shelly "+record+" successful"))
        .catch(err => handleError(err));
        getShellyRecords();
        
    }
    

    function handleFormSubmit(data,isAddOperation,isCancelOperation)
    {
        props.setFormShown(false);
        if(isCancelOperation === true)
        {
            console.log("Cancelled operation");
            return 0;
        }
        console.log("handleFormSubmit"+data+"-add-operation-"+isAddOperation);
        if(isAddOperation === true)
            addShellyRecord(data);
        else
            editShellyRecord(data);
    }
    

    return(
        <>
        {isAddDisabled && (
            <Typography style={{ color: '#b26a00', marginBottom: 8, textAlign: 'left' }}>
                Only one shelly lock is allowed per location. Delete the existing one to add another.
            </Typography>
        )}
        <ParentComponent
        data={shellyRecords}
        columns={columnInfo}
        form={ShellyLockForm}
        formTitle={"Shelly Lock"}
        handleFormSubmitFunc={handleFormSubmit}
        setFormShownFlag={props.setFormShown}
        alreadySelectedOwnRow={props.alreadySelectedOwnRow}
        deleteFunc={deleteShellyRecord}
        setSelectedRow={props.setSelectedRow}
        selectedLocationRow={props.LocationRow}
        isAddDisabled={isAddDisabled}
        />
        </>
    );
}
export default ShellyLock;